import { walkTreeByLevel } from "@voltalis/frontend-utils";

type GenericNode<T> = {
  children: T[];
};

/**
 * A leaf descendant is a node without children
 */
export function countAllLeafDescendants<T extends GenericNode<T>>(
  node: T,
  enableCount?: (child: T) => boolean,
): number {
  const allLeafDescendants = getAllLeafDescendants(node, enableCount);
  return allLeafDescendants.length;
}

export function getAllLeafDescendants<T extends GenericNode<T>>(node: T, enableCount?: (child: T) => boolean): T[] {
  let allLeafDescendants: T[] = [];

  for (const child of walkTreeByLevel(node.children)) {
    if (enableCount && !enableCount(child)) continue;
    if (child.children.length) continue;
    allLeafDescendants.push(child);
  }

  return allLeafDescendants;
}
